import { render, staticRenderFns } from "./EndOfLifeDisposalMainSection.vue?vue&type=template&id=824bc26c"
import script from "./EndOfLifeDisposalMainSection.vue?vue&type=script&lang=js"
export * from "./EndOfLifeDisposalMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports